import React from 'react';
import { includes } from 'lodash';
import cx from 'classnames';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import { WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL } from '../../../../../store/modules/widget/models';
import WidgetItemListWrap from '../../WidgetItemListWrap';
import {
  SELECTED_SEARCH_EVENT_LIST_TABLE_EMPTY_TEXT,
  SEARCH_EVENT_LIST_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/widgetConstants';
import { columns } from './columns';
import './SearchEventListModal.scss';

const SearchEventListModal = (props) => {
  const {
    isOpen,
    closeModal,
    onSubmit,
    getEventList,
    data,
    onCheckEvent,
    selectedEventIdList,
    selectedEventList,
    openImgViewModal,
    openEventItemListModal,
  } = props;
  const { listData, linkType } = data;
  const { list, filterOption, pagination, summary = {} } = listData;

  return (
    <Modal
      title="기획전 검색"
      isOpen={isOpen}
      width={920}
      height={910}
      isFooter={true}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="search-event-list-modal-wrap">
        <WidgetItemListWrap title="선택된 기획전">
          <Table
            className="selected-event-list-table"
            emptyText={SELECTED_SEARCH_EVENT_LIST_TABLE_EMPTY_TEXT}
            data={selectedEventList}
            sortable={false}
            defaultPageSize={1}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedEventIdList}
            onCheck={(list) => onCheckEvent(list)}
            columns={() =>
              columns({
                openImgViewModal,
                openEventItemListModal,
              })
            }
          />
        </WidgetItemListWrap>

        <WidgetItemListWrap title="기획전 리스트">
          <TableWithSummary
            className="event-list-table"
            totalCnt={summary.totalCnt}
            emptyText={SEARCH_EVENT_LIST_TABLE_EMPTY_TEXT}
            initialOption={{
              filterOption: WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL[linkType],
            }}
            data={list}
            maxHeight={600}
            showPagination
            filterOption={filterOption}
            pagination={pagination}
            getList={getEventList}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedEventIdList}
            onCheck={(list) => onCheckEvent(list)}
            columns={(utils) =>
              columns({
                openImgViewModal,
                openEventItemListModal,
                ...utils,
              })
            }
            getTdProps={(state, rowInfo) => {
              return {
                className: cx({ selected: includes(selectedEventIdList, rowInfo.original.id) }),
              };
            }}
          />
        </WidgetItemListWrap>
      </div>
    </Modal>
  );
};

export default SearchEventListModal;
